import { onBeforeUnmount, onMounted, ref } from 'vue'

// Reactive `window.matchMedia(query).matches`. Defaults to `fallback` before
// mount / where matchMedia is unavailable (SSR, older test envs).
export function useMediaQuery(query: string, fallback = false) {
  const matches = ref(fallback)
  let mediaQuery: MediaQueryList | null = null
  const sync = () => {
    matches.value = mediaQuery?.matches ?? fallback
  }

  onMounted(() => {
    if (typeof window.matchMedia !== 'function') return
    mediaQuery = window.matchMedia(query)
    sync()
    mediaQuery.addEventListener('change', sync)
  })

  onBeforeUnmount(() => {
    mediaQuery?.removeEventListener('change', sync)
    mediaQuery = null
  })

  return matches
}
